<template>
  <div>

<!--    <table class="table table-hover" style="width:400px">-->
<!--&lt;!&ndash;      <thead class="thead-light">&ndash;&gt;-->
<!--&lt;!&ndash;      <tr>&ndash;&gt;-->
<!--&lt;!&ndash;        <th>標籤1</th>&ndash;&gt;-->
<!--&lt;!&ndash;        <th>標籤2</th>&ndash;&gt;-->
<!--&lt;!&ndash;        <th>標籤3</th>&ndash;&gt;-->
<!--&lt;!&ndash;      </tr>&ndash;&gt;-->
<!--&lt;!&ndash;      </thead>&ndash;&gt;-->
<!--      <tbody>-->
<!--      <tr>-->
<!--        <td class="text-left">-->
<!--          App使用-->
<!--        </td>-->
<!--        <td class="text-left">-->

<!--          今天使用人次 {{data.App_Today}}-->
<!--        </td>-->
<!--      </tr>-->

<!--      <tr>-->
<!--        <td class="text-left">-->

<!--        </td>-->
<!--        <td class="text-left">-->
<!--          本周使用人次 {{data.App_ThisWeek}}-->
<!--        </td>-->
<!--      </tr>-->

<!--      <tr>-->
<!--        <td class="text-left">-->

<!--        </td>-->
<!--        <td class="text-left">-->
<!--          本月使用人次 {{data.App_ThisMonth}}-->
<!--        </td>-->
<!--      </tr>-->

<!--      <tr>-->
<!--        <td class="text-left">-->
<!--          個案人數-->
<!--        </td>-->
<!--        <td class="text-left">-->
<!--          <router-link to="/MemberList">總共 {{data.Case_All}}</router-link> &nbsp;&nbsp;-->
<!--           <router-link to="/MemberList?isFinish=true">已完成確認 {{data.Case_IsFinish}}</router-link>&nbsp;&nbsp;-->
<!--          <router-link to="/MemberList?isFinish=false">未完成確認 {{data.Case_IsUnFinish}}</router-link>-->
<!--        </td>-->
<!--      </tr>-->

<!--      <tr>-->
<!--        <td class="text-left">-->

<!--        </td>-->
<!--        <td class="text-left">-->
<!--          <router-link to="/MemberList?riskLevel=A">A級 {{data.Case_A}}</router-link>-->
<!--        </td>-->
<!--      </tr>-->

<!--      <tr>-->
<!--        <td class="text-left">-->

<!--        </td>-->
<!--        <td class="text-left">-->
<!--          <router-link to="/MemberList?riskLevel=B">B級 {{data.Case_B}}</router-link>-->
<!--        </td>-->
<!--      </tr>-->

<!--      <tr>-->
<!--        <td class="text-left">-->

<!--        </td>-->
<!--        <td class="text-left">-->
<!--          <router-link to="/MemberList?riskLevel=C">C級 {{data.Case_C}}</router-link>-->
<!--        </td>-->
<!--      </tr>-->

<!--      <tr>-->
<!--        <td class="text-left">-->

<!--        </td>-->
<!--        <td class="text-left">-->
<!--          <router-link to="/MemberList?riskLevel=D">D級 {{data.Case_D}}</router-link>-->
<!--        </td>-->
<!--      </tr>-->
<!--      <tr>-->
<!--        <td class="text-left">-->
<!--          待處理個案-->
<!--        </td>-->
<!--        <td class="text-left">-->

<!--        </td>-->
<!--      </tr>-->
<!--      <tr v-for="(tag,index) in data.Tags" :key="index">-->
<!--        <td class="text-left">-->

<!--        </td>-->
<!--        <td class="text-left">-->
<!--          <router-link :to="'/CaseMagList?tag='+tag.Tag">{{tag.Tag}} {{tag.TagCount}}</router-link>-->
<!--        </td>-->
<!--      </tr>-->
<!--      </tbody>-->
<!--    </table>-->

<!--    <a role="button" class="btn btn-primary" href="#" @click="test01()">Test</a>-->
  </div>
</template>

<script>
import apiAdmin from "@/taylorCommon/apiAdmin";
/**

 **/
// import apiTzsci from "./js/apiTzsci";


export default {
  //name: "index",
  // props: [""],
  data: function () {
    return {
      id: "",
      dataReady: false,
      formData: {
        name: "",
      },
      data:{}
    };
  },
  methods: {
    async loadData() {
      // let data=await apiTzsci.api_Admin_GetHome();
      //
      // this.data=data;
    },
    test01(){
      apiAdmin.api_admWebContent_QueryContent_byUserId("test","12").then((data)=>{
        debugger // eslint-disable-line
        if (data.data.status==="success") {
          alert("密碼修改成功");
        } else {
          alert(data.data.msg);
        }
      })
    }
  },
  mounted() {
    this.loadData()
  },
}
</script>

<style scoped>

</style>
